"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jun 21 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var FamilyCreatedDTOConverter_1 = require("./conversions/dto/FamilyCreatedDTOConverter");

var FamilyCreatedDTOConverterImpl_1 = require("./conversions/dto/FamilyCreatedDTOConverterImpl");

var FamilyBindingConverter_1 = require("./conversions/FamilyBindingConverter");

var FamilyBindingConverterImpl_1 = require("./conversions/FamilyBindingConverterImpl");

var FamilyConverter_1 = require("./conversions/FamilyConverter");

var FamilyConverterImpl_1 = require("./conversions/FamilyConverterImpl");
/**
 * Configures family app module.
 *
 * @author JMe
 */


var FamilyAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(FamilyAppModule, _AppModule_1$AppModul);

  function FamilyAppModule() {
    var _this;

    _classCallCheck(this, FamilyAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilyAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'familyAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FamilyAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(FamilyBindingConverter_1.FamilyBindingConverter).to(FamilyBindingConverterImpl_1.FamilyBindingConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(FamilyConverter_1.FamilyConverter).to(FamilyConverterImpl_1.FamilyConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(FamilyCreatedDTOConverter_1.FamilyCreatedDTOConverter).to(FamilyCreatedDTOConverterImpl_1.FamilyCreatedDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return FamilyAppModule;
}(AppModule_1.AppModule);

exports.FamilyAppModule = FamilyAppModule;